import React from "react";
import { Box, IconButton } from "@mui/material";
import { TextField } from "@mui/material";
import dayjs from "dayjs";
import dayOfYear from "dayjs/plugin/dayOfYear";
import {
  reorderUsers,
  userStatsSummary,
} from "./ProgramStatistics/ProgramStatistics";
import SearchIcon from "@mui/icons-material/Search";
import { StyledButtonMain } from "../common/Buttons";
import EngagementsDashboard from "./EngagementsDashboard";
import EngagementsSearchResult from "./EngagementsSearchResult";
import { axiosInstance } from "../../utils/networking";
import Fuse from "fuse.js";
dayjs.extend(dayOfYear);

const Engagements = () => {
  const [searchTerm, setSearchTerm] = React.useState("");
  const [searchFlag, setSearchFlag] = React.useState(false);
  const [searchResults, setSearchResults] = React.useState<{
    case_results: any[];
    activity_results: any[];
    referral_docs: any[];
  }>({
    case_results: [],
    activity_results: [],
    referral_docs: [],
  });
  const handleKeyDown = (event: React.KeyboardEvent) => {
    if (event.key === "Enter") {
      handleSearch();
    }
  };

  const handleSearch = () => {
    if (searchTerm.trim() !== "") {
      setSearchFlag(true);
      axiosInstance
        .post("/search", {
          searchTerm: searchTerm,
        })
        .then((response) => {
          const { case_results, activity_results, referral_docs } =
            response.data;
          const options = {
            includeScore: true,
            keys: [
              { name: "firmRecord.Company Name", weight: 0.5 },
              { name: "firmRecord.Contact", weight: 0.5 },
            ],
            threshold: 0.5,
            distance: 100, // raise for more tolerance on position
            ignoreLocation: true, // makes short/typo'd queries match better
            minMatchCharLength: 2,
          };

          const fuse = new Fuse(case_results, options);
          const result = fuse.search(searchTerm);
          const matchedCases: any[] = result.map((res) => res.item);
          const umatchedCases = case_results.filter((item: any) => {
            return !matchedCases.includes(item);
          });
          setSearchResults({
            case_results: matchedCases.concat(umatchedCases),
            activity_results,
            referral_docs,
          });
        })
        .catch((error) => {
          console.error("Error during search:", error);
        });
    }
  };

  return (
    <>
      <Box sx={{ width: "100%", marginTop: "-55px", paddingBottom: "15px" }}>
        <Box>
          <TextField
            fullWidth
            variant="outlined"
            size="small"
            placeholder="Search cases..."
            value={searchTerm}
            onKeyDown={handleKeyDown}
            onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
              setSearchTerm(e.target.value)
            }
            sx={{ background: "white", width: "50%" }}
            InputProps={{
              endAdornment: (
                <IconButton
                  aria-label="search"
                  edge="end"
                  onClick={handleSearch}
                >
                  <SearchIcon />
                </IconButton>
              ),
            }}
          />
          <StyledButtonMain
            sx={{ marginLeft: "10px" }}
            variant="contained"
            color="primary"
            onClick={handleSearch}
          >
            Search
          </StyledButtonMain>
          {searchFlag ? (
            <StyledButtonMain
              sx={{ marginLeft: "10px" }}
              variant="contained"
              color="primary"
              onClick={() => {
                setSearchFlag(false);
              }}
            >
              Clear Search
            </StyledButtonMain>
          ) : (
            <></>
          )}
        </Box>
      </Box>
      <Box sx={{ display: searchFlag ? "block" : "none" }}>
        <EngagementsSearchResult
          searchTerm={searchTerm}
          searchResults={searchResults}
        />
      </Box>
      <Box sx={{ display: searchFlag ? "none" : "block" }}>
        <EngagementsDashboard />
      </Box>
    </>
  );
};

export default Engagements;
